/**
 * Imports
 */
import { Dropdown as AntdDropdown } from 'antd';
import { styled } from 'theme';

/**
 * Dropdown override style
 */
const Dropdown = styled(AntdDropdown)`
  && {
    cursor: pointer;
    .ant-dropdown-menu {
      padding: 8px;
    }
  }
`;

/**
 * Exports
 */
export { Dropdown };
